import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/base/buttons'

const TwFooterContainer = tw.div`
  flex
  items-center
  justify-end
  gap-12
  px-24
  pt-11
  pb-23
`

export interface Props {
  close: () => void
  submit: () => void
  primaryBtnText?: string
  closeBtnText?: string
  primaryBtnDisabled?: boolean
  isDelete?: boolean
  type: 'two-buttons' | 'one-button'
  hidePrimaryBtn?: boolean
}

export const DialogFooter = (props: Props) => {
  const {close, submit, isDelete, type} = props
  const {primaryBtnText, closeBtnText, hidePrimaryBtn, primaryBtnDisabled} =
    props

  return (
    <TwFooterContainer>
      {type === 'two-buttons' && (
        <Button tabIndex={0} color="secondary" onClick={close} rounded={'8'}>
          {closeBtnText ?? Lang.msg.cancel}
        </Button>
      )}

      {!hidePrimaryBtn && (
        <Button
          tabIndex={0}
          color={isDelete ? 'error' : 'primary'}
          onClick={submit}
          rounded={'8'}
          disabled={primaryBtnDisabled}
        >
          {primaryBtnText ?? Lang.msg.save}
        </Button>
      )}
    </TwFooterContainer>
  )
}
